import { directive as onClickOutside } from 'vue-on-click-outside';
import { VTooltip } from 'v-tooltip';

const modal = {
  inserted(el, binding, vnode) {
    el.addEventListener('click', e => {
      e.preventDefault();
      vnode.context.$root.$emit('modal-open', binding.arg);
    });
  }
};

export default {
  modal,
  'on-click-outside': onClickOutside,
  'tooltip': VTooltip
};
